const DownArrow = (
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="15" cy="15" r="15" fill="#F5F5F5"/>
<path d="M16.0853 19.6669L22.7604 12.9917C22.9149 12.8373 23 12.6312 23 12.4114C23 12.1917 22.9149 11.9856 22.7604 11.8312L22.2689 11.3396C21.9487 11.0197 21.4282 11.0197 21.1084 11.3396L15.5031 16.9449L9.89157 11.3334C9.73706 11.179 9.53108 11.0938 9.31145 11.0938C9.09158 11.0938 8.8856 11.179 8.73097 11.3334L8.23963 11.825C8.08512 11.9795 8 12.1854 8 12.4052C8 12.625 8.08512 12.8311 8.23963 12.9854L14.9208 19.6669C15.0758 19.8216 15.2827 19.9066 15.5027 19.9061C15.7236 19.9066 15.9304 19.8216 16.0853 19.6669Z" fill="#0A8A95"/>
</svg>

)

export default DownArrow